// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__27W_x","balanceDisclaimer":"posDashboard_balanceDisclaimer__1CGXd"};